'use client'

import { cn } from '../../lib'
import type { ChipProps } from './chip.types'

import { chipStyle } from './chip.css'

const Chip = ({ className, children, selected, fontWeight = 'bold', direction, size, ...props }: ChipProps) => {
  return (
    <button
      {...props}
      className={cn([`font-${fontWeight}`, 'tracking-[-0.7px]'], chipStyle({ direction, size }), className)}
      data-selected={selected ? 'selected' : 'un-selected'}
      aria-selected={selected}
    >
      {children}
    </button>
  )
}

Chip.displayName = 'Chip'

export default Chip
